import { useSelector } from 'react-redux';

import { apiUrl } from '../config/app';
import { endpoints, queryParams } from '../constants/routing';
import useAuthQuery from '../hooks/useAuthQuery';
import { selectUserAccessToken } from '../store/selectors/auth';
import { IFetchReportsResponse, IReportsRequest } from '../types/reports';
import { QueryRequest } from '../utils/request';

const EngagementService = {
  getEngagements: (params: Partial<IReportsRequest>, token?: string) => {
    const { one_link_id, ...requestBody } = params;

    const endpoint = `${apiUrl}${endpoints.reports}`;

    return QueryRequest<IFetchReportsResponse>(
      {
        endpoint,
        method: 'POST',
        body: JSON.stringify(requestBody),
        queryParams: one_link_id ? { [queryParams.oneLinkId]: one_link_id } : {},
      },
      token,
    ).then((res) => {
      if (res.ok) {
        return {
          engagements: res.body.engagements,
          total_count: res.body.total_count,
        };
      }
      throw res;
    });
  },
};

export const useGetEngagements = (params: Partial<IReportsRequest>) => {
  const token = useSelector(selectUserAccessToken);

  return useAuthQuery({
    queryKey: ['engagements', params],
    queryFn: async () => {
      const data = await EngagementService.getEngagements(params, token);
      return data ?? null;
    },
    select: (data) => ({
      engagements: data?.engagements ?? [],
      total_count: data?.total_count ?? 0,
      isLoading: !data,
    }),
  });
};
